/* Shopify Inbox renders its chat button inside <shopify-chat>'s shadow root, so a
   theme stylesheet cannot reach it. The shadow root is open, so we can append a style
   element to it. The rule reads the same custom properties brs-widgets.css sets on
   :root, because custom properties inherit across the shadow boundary. That keeps all
   the positioning numbers in the stylesheet and none of them here.

   The element is injected asynchronously and its shadow root can attach after the
   element itself, so we watch for both and stop once the style is in. */
(function () {
  const STYLE_ID = 'brs-chat-position';
  const CSS = `
    .activator-nudge,
    .activator-nudge--right,
    .activator-nudge--left {
      top: auto !important;
      left: auto !important;
      right: var(--brs-widget-right, 1.6rem) !important;
      bottom: var(--brs-widget-bottom, 1.6rem) !important;
    }
  `;

  let done = false;

  function apply() {
    if (done) return true;
    if (!window.matchMedia('(max-width: 989px)').matches) return false;

    const host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById(STYLE_ID)) {
      done = true;
      return true;
    }
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    host.shadowRoot.appendChild(style);
    done = true;
    return true;
  }

  if (apply()) return;

  const observer = new MutationObserver(function () {
    if (apply()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* The shadow root can attach without any further DOM mutation we observe, so poll
     briefly as well, then give up rather than run forever. */
  let tries = 0;
  const timer = setInterval(function () {
    tries += 1;
    if (apply() || tries > 40) {
      clearInterval(timer);
      observer.disconnect();
    }
  }, 250);

  /* If the viewport crosses the breakpoint after load, try again. */
  window.addEventListener('resize', function () {
    if (!done) apply();
  });
})();
